const routes = [
  {
    path: "/",
    component: () => import("./views/home"),
    meta: { authRequired: true, menu: { label: "Dashboard" } },
  },
  {
    path: "/login",
    component: () => import("./views/login"),
    meta: { authRequired: false },
  },
  {
    path: "/login/secretaria",
    component: () => import("./views/login-secretaria"),
    meta: { authRequired: false },
  },
  {
    path: "/login/token/:token",
    component: () => import("./views/login-in"),
    meta: { authRequired: false },
  },
  {
    path: "/platforms",
    component: () => import("./views/platforms"),
    meta: { authRequired: false },
  },
  {
    path: "/logout",
    redirect: "/login",
  },
  {
    path: "/register",
    component: () => import("./views/register/index"),
    meta: { authRequired: false },
  },
  {
    path: "/register/:sponsor",
    component: () => import("./views/register/index"),
    meta: { authRequired: false },
  },
  {
    path: "/primeiroacesso",
    component: () => import("./views/register/first"),
    meta: { authRequired: false },
  },
  {
    path: "/password-forgot",
    component: () => import("./views/password-forgot"),
    meta: { authRequired: false },
  },
  {
    // Histórico de versões (utils/versao.js). Sem `meta.menu`: não entra no
    // catálogo de permissões da secretária — é liberada para todos em
    // utils/regional-user-permissions.js.
    path: "/novidades",
    component: () => import("./views/novidades"),
    meta: { authRequired: true },
  },
  {
    path: "/account",
    component: () => import("./views/account/account"),
    meta: { authRequired: true, menu: { label: "Conta - Minha Conta" } },
  },
  {
    path: "/account/indication",
    component: () => import("./views/account/indication"),
    meta: { authRequired: true, menu: { label: "Conta - Link de Indicacao" } },
  },
  {
    path: "/account/address",
    component: () => import("./views/account/address"),
    meta: { authRequired: true, menu: { label: "Conta - Meus Enderecos" } },
  },
  {
    path: "/account/password",
    component: () => import("./views/account/password"),
    meta: { authRequired: true, menu: { label: "Conta - Minha Senha" } },
  },
  {
    path: "/account/password/security",
    component: () => import("./views/account/password-security"),
    meta: { authRequired: true, menu: { label: "Conta - Senha de Seguranca" } },
  },
  {
    path: "/account/password/security/:token",
    component: () => import("./views/account/password-security"),
    meta: { authRequired: true },
  },
  {
    path: "/account/pix",
    component: () => import("./views/account/pix"),
    meta: { authRequired: true, menu: { label: "Conta - Dados Bancarios" } },
  },
  {
    path: "/usuarios",
    component: () => import("./views/regional-users/index"),
    meta: { authRequired: true },
  },
  {
    path: "/documents",
    component: () => import("./views/documents/index"),
    meta: { authRequired: true, menu: { label: "Conta - Meus Documentos" } },
  },
  {
    path: "/contracts",
    component: () => import("./views/contracts/list"),
    meta: { authRequired: true, menu: { label: "Conta - Meus Contratos" } },
  },
  {
    path: "/contracts/:id",
    component: () => import("./views/contracts/view"),
    meta: { authRequired: true },
  },
  {
    path: "/wallet/extract",
    component: () => import("./views/wallet/extract"),
    meta: { authRequired: true },
  },
  {
    path: "/wallet/withdrawal",
    component: () => import("./views/wallet/withdrawal"),
    meta: { authRequired: true },
  },
  {
    path: "/wallet/withdrawal/history",
    component: () => import("./views/wallet/withdrawal-history"),
    meta: { authRequired: true },
  },
  {
    path: "/network/diretos",
    component: () => import("./views/network/diretos"),
    meta: { authRequired: true, menu: { label: "Rede - Diretos" } },
  },
  {
    path: "/network/indicados",
    component: () => import("./views/network/indication"),
    meta: { authRequired: true, menu: { label: "Rede - Indicados" } },
  },
  {
    path: "/network/indicados/:id",
    component: () => import("./views/network/indication-documents"),
    meta: { authRequired: true },
  },
  {
    path: "/network/equipe",
    component: () => import("./views/network/equipe"),
    meta: { authRequired: true, menu: { label: "Rede - Equipe" } },
  },
  {
    path: "/network/matriz",
    component: () => import("./views/network/matriz"),
    meta: { authRequired: true, menu: { label: "Rede - Matriz" } },
  },
  {
    path: "/apvs/brasil/dashboard",
    component: () => import("./views/apvs/brasil/dashboard"),
    meta: { authRequired: true, menu: { label: "APVS Brasil - Dashboard" } },
  },
  {
    path: "/apvs/brasil/rankings",
    component: () => import("./views/apvs/brasil/rankings"),
    meta: { authRequired: true },
  },
  {
    path: "/apvs/brasil/adesoes",
    component: () => import("./views/apvs/brasil/adesoes"),
    meta: { authRequired: true, menu: { label: "APVS Brasil - Adesoes" } },
  },
  {
    path: "/apvs/brasil/metas",
    component: () => import("./views/apvs/brasil/metas"),
    meta: { authRequired: true, menu: { label: "APVS Brasil - Metas" } },
  },
  {
    path: "/apvs/brasil/recorrente",
    component: () => import("./views/apvs/brasil/recorrente"),
    meta: { authRequired: true, menu: { label: "APVS Brasil - Recorrente" } },
  },
  {
    path: "/apvs/brasil/comissionamento",
    component: () => import("./views/apvs/brasil/comissionamento"),
    meta: { authRequired: true, menu: { label: "APVS Brasil - Vitalicio" } },
  },
  {
    path: "/apvs/truck/dashboard",
    component: () => import("./views/apvs/truck/dashboard"),
    meta: { authRequired: true, menu: { label: "APVS Truck - Dashboard" } },
  },
  {
    path: "/apvs/truck/adesoes",
    component: () => import("./views/apvs/truck/adesoes"),
    meta: { authRequired: true, menu: { label: "APVS Truck - Adesoes" } },
  },
  {
    path: "/apvs/truck/metas",
    component: () => import("./views/apvs/truck/metas"),
    meta: { authRequired: true, menu: { label: "APVS Truck - Metas" } },
  },
  {
    path: "/apvs/truck/recorrente",
    component: () => import("./views/apvs/truck/recorrente"),
    meta: { authRequired: true, menu: { label: "APVS Truck - Recorrente" } },
  },
  {
    path: "/apvs/truck/comissionamento",
    component: () => import("./views/apvs/truck/comissionamento"),
    meta: { authRequired: true, menu: { label: "APVS Truck - Vitalicio" } },
  },
  {
    path: "/apvs/brasil/gerente",
    component: () => import("./views/apvs/brasil/gerente"),
    meta: { authRequired: true },
  },
  {
    path: "/apvs/brasil/diretor",
    component: () => import("./views/apvs/brasil/diretor"),
    meta: { authRequired: true },
  },
  {
    path: "/apvs/brasil/rastreador",
    component: () => import("./views/apvs/brasil/rastreador"),
    meta: { authRequired: true, menu: { label: "APVS Brasil - Rastreador" } },
  },
  {
    path: "/apvs/truck/rastreador",
    component: () => import("./views/apvs/truck/rastreador"),
    meta: { authRequired: true, menu: { label: "APVS Truck - Rastreador" } },
  },
  {
    path: "/apvs/brasil/global",
    component: () => import("./views/apvs/brasil/global"),
    meta: { authRequired: true },
  },
  // Rankings — novo modelo de reconhecimento (portado do biTeams). As 4 trilhas usam a mesma
  // view, parametrizada por `meta.trilha`. O path é também a permissão da secretária e a URI da
  // API (salesteams_app_api: biteams/rk-* → controllers/Rankings.php), por isso começa com
  // /biteams mesmo vivendo no app do consultor.
  {
    path: "/biteams/rk-regras",
    component: () => import("./views/rankings/regras"),
    meta: { authRequired: true, menu: { label: "Rankings - Regras" } },
  },
  {
    path: "/biteams/rk-consultores",
    component: () => import("./views/rankings/ranking"),
    meta: { authRequired: true, trilha: "consultores", menu: { label: "Rankings - Consultores" } },
  },
  {
    path: "/biteams/rk-home",
    component: () => import("./views/rankings/ranking"),
    meta: { authRequired: true, trilha: "home", menu: { label: "Rankings - Home Office" } },
  },
  {
    path: "/biteams/rk-executiva",
    component: () => import("./views/rankings/ranking"),
    meta: { authRequired: true, trilha: "executiva", menu: { label: "Rankings - Executiva" } },
  },
  {
    path: "/biteams/rk-gerentes",
    component: () => import("./views/rankings/ranking"),
    meta: { authRequired: true, trilha: "gerentes", menu: { label: "Rankings - Gerentes" } },
  },
  // Regras e Regulamentos do Ranking Nacional/Estadual (uma seção por ranking + passo a passo no
  // i4pro). Sem `menu.label` de propósito: não é permissão própria da secretária — ela vê a tela se
  // tiver algum ranking do Nacional ou do Estadual (utils/regional-user-permissions.js).
  {
    path: "/biteams/rk-regulamento",
    component: () => import("./views/rankings/regulamento"),
    meta: { authRequired: true },
  },
  // Resumo de todos os rankings Nacional/Estadual (um card por ranking). Página oculta: sem item no
  // menu e sem `menu.label` — cada card segue a visibilidade do subitem do menu.
  {
    path: "/biteams/rk-resumo",
    component: () => import("./views/rankings/resumo"),
    meta: { authRequired: true },
  },
  // Ranking Nacional (Brasil / Truck) — os 10 rankings de indicador único do biTeams. Uma view só,
  // parametrizada por `meta.rankingNacional` (ver utils/ranking-nacional.js). Mesmo esquema dos
  // Rankings acima: path == permissão da secretária == URI da API (Rankings.php, Nacional*).
  {
    path: "/biteams/rk-nacional-brasil-ho-boletos",
    component: () => import("./views/rankings/nacional"),
    meta: { authRequired: true, rankingNacional: "nacional-brasil-ho-boletos", menu: { label: "Ranking Nacional - Brasil - Top 20 Home Office Boletos Quitados" } },
  },
  {
    path: "/biteams/rk-nacional-brasil-consultores-boletos",
    component: () => import("./views/rankings/nacional"),
    meta: { authRequired: true, rankingNacional: "nacional-brasil-consultores-boletos", menu: { label: "Ranking Nacional - Brasil - Top 20 Consultores Boletos Quitados" } },
  },
  {
    path: "/biteams/rk-nacional-brasil-regional-adesao",
    component: () => import("./views/rankings/nacional"),
    meta: { authRequired: true, rankingNacional: "nacional-brasil-regional-adesao", menu: { label: "Ranking Nacional - Brasil - Top 20 Regional Adesão" } },
  },
  {
    path: "/biteams/rk-nacional-brasil-regional-boletos",
    component: () => import("./views/rankings/nacional"),
    meta: { authRequired: true, rankingNacional: "nacional-brasil-regional-boletos", menu: { label: "Ranking Nacional - Brasil - Top 20 Regional Boletos Quitados" } },
  },
  {
    path: "/biteams/rk-nacional-brasil-regional-ticket",
    component: () => import("./views/rankings/nacional"),
    meta: { authRequired: true, rankingNacional: "nacional-brasil-regional-ticket", menu: { label: "Ranking Nacional - Brasil - Top 20 Regional Ticket Médio" } },
  },
  // Inadimplência desativada (2026-11-04; ver utils/ranking-nacional.js): link antigo vai para o
  // ranking de Adesão e a permissão some do catálogo da secretária (sem `menu.label`).
  {
    path: "/biteams/rk-nacional-brasil-regional-inadimplencia",
    redirect: "/biteams/rk-nacional-brasil-regional-adesao",
  },
  {
    path: "/biteams/rk-nacional-brasil-regional-cons-ativos",
    component: () => import("./views/rankings/nacional"),
    meta: { authRequired: true, rankingNacional: "nacional-brasil-regional-cons-ativos", menu: { label: "Ranking Nacional - Brasil - Top 20 Regional Consultores Ativos" } },
  },
  {
    path: "/biteams/rk-nacional-truck-regional-adesao",
    component: () => import("./views/rankings/nacional"),
    meta: { authRequired: true, rankingNacional: "nacional-truck-regional-adesao", menu: { label: "Ranking Nacional - Truck - Top 10 Regional Adesão" } },
  },
  {
    path: "/biteams/rk-nacional-truck-regional-boletos",
    component: () => import("./views/rankings/nacional"),
    meta: { authRequired: true, rankingNacional: "nacional-truck-regional-boletos", menu: { label: "Ranking Nacional - Truck - Top 10 Regional Boletos Quitados" } },
  },
  {
    path: "/biteams/rk-nacional-truck-consultor-adesao",
    component: () => import("./views/rankings/nacional"),
    meta: { authRequired: true, rankingNacional: "nacional-truck-consultor-adesao", menu: { label: "Ranking Nacional - Truck - Top 10 Consultor Adesão" } },
  },
  // Ranking Estadual (Brasil / Truck) — os mesmos rankings do Nacional recortados pela diretoria
  // do usuário logado (a API resolve a diretoria; ver utils/ranking-estadual.js). Mesma view do
  // Nacional, parametrizada por `meta.rankingEstadual`; path == permissão da secretária == URI da API.
  {
    path: "/biteams/rk-estadual-brasil-regional-adesao",
    component: () => import("./views/rankings/nacional"),
    meta: { authRequired: true, rankingEstadual: "estadual-brasil-regional-adesao", menu: { label: "Ranking Estadual - Brasil - Top 20 Regionais Adesão" } },
  },
  {
    path: "/biteams/rk-estadual-brasil-regional-ticket",
    component: () => import("./views/rankings/nacional"),
    meta: { authRequired: true, rankingEstadual: "estadual-brasil-regional-ticket", menu: { label: "Ranking Estadual - Brasil - Top 20 Regionais Ticket Médio" } },
  },
  {
    path: "/biteams/rk-estadual-brasil-consultores-adesao",
    component: () => import("./views/rankings/nacional"),
    meta: { authRequired: true, rankingEstadual: "estadual-brasil-consultores-adesao", menu: { label: "Ranking Estadual - Brasil - Top 20 Consultores Adesões" } },
  },
  {
    path: "/biteams/rk-estadual-brasil-consultores-boletos",
    component: () => import("./views/rankings/nacional"),
    meta: { authRequired: true, rankingEstadual: "estadual-brasil-consultores-boletos", menu: { label: "Ranking Estadual - Brasil - Top 20 Consultores Boletos Quitados" } },
  },
  {
    path: "/biteams/rk-estadual-truck-regional-adesao",
    component: () => import("./views/rankings/nacional"),
    meta: { authRequired: true, rankingEstadual: "estadual-truck-regional-adesao", menu: { label: "Ranking Estadual - Truck - Top 05 Regionais Adesão" } },
  },
  {
    path: "/biteams/rk-estadual-truck-regional-boletos",
    component: () => import("./views/rankings/nacional"),
    meta: { authRequired: true, rankingEstadual: "estadual-truck-regional-boletos", menu: { label: "Ranking Estadual - Truck - Top 05 Regionais Boletos Quitados" } },
  },
  {
    path: "/biteams/rk-estadual-truck-consultor-adesao",
    component: () => import("./views/rankings/nacional"),
    meta: { authRequired: true, rankingEstadual: "estadual-truck-consultor-adesao", menu: { label: "Ranking Estadual - Truck - Top 05 Consultores Adesão" } },
  },
  {
    path: "/biteams/rk-estadual-truck-consultores-boletos",
    component: () => import("./views/rankings/nacional"),
    meta: { authRequired: true, rankingEstadual: "estadual-truck-consultores-boletos", menu: { label: "Ranking Estadual - Truck - Top 05 Consultores Boletos Quitados" } },
  },
  // Acessa — Leads/Clientes/Adesão/Recorrente/Graduação aparecem no menu (menu-map.js) e passam
  // por `canAccess`, mas estavam com `hidden: true` e por isso NUNCA eram oferecidas na tela de
  // permissões da secretária: para ela o grupo inteiro sumia. Liberadas no catálogo. A API de
  // cada uma (`acessa/<tela>`) já resolve para o mesmo path pela convenção de
  // App::resolvePermissionFromUri(), sem alias.
  {
    path: "/acessa/leads",
    component: () => import("./views/acessa/leads"),
    meta: { authRequired: true, menu: { label: "Acessa - Leads" } },
  },
  {
    path: "/acessa/clientes",
    component: () => import("./views/acessa/clientes"),
    meta: { authRequired: true, menu: { label: "Acessa - Clientes" } },
  },
  {
    // Continua `hidden: true` de propósito: aqui a flag é também o gate de visibilidade do item
    // no menu (ver menu-map.js) — a tela nunca foi publicada.
    path: "/acessa/qrcodes",
    component: () => import("./views/acessa/qrcodes"),
    meta: { authRequired: true, menu: { label: "Acessa - QR Codes", hidden: true } },
  },
  {
    path: "/acessa/adesao",
    component: () => import("./views/acessa/adesao"),
    meta: { authRequired: true, menu: { label: "Acessa - Adesao" } },
  },
  {
    path: "/acessa/recorrente",
    component: () => import("./views/acessa/recorrente"),
    meta: { authRequired: true, menu: { label: "Acessa - Recorrente" } },
  },
  {
    // O item "Graduação" já existia no menu lateral (side-nav.vue) e a view já
    // existia e consumia `acessa/graduacao` da API, mas a rota nunca foi
    // registrada aqui: clicar no item não casava com nenhuma rota e levava a
    // lugar nenhum.
    path: "/acessa/graduacao",
    component: () => import("./views/acessa/graduacao"),
    meta: { authRequired: true, menu: { label: "Acessa - Graduacao" } },
  },
  {
    path: "/downloads",
    component: () => import("./views/downloads"),
    meta: { authRequired: true, menu: { label: "Downloads" } },
  },
  {
    // Minhas Metas (planejamento + acompanhamento APVS). `menu.label` também torna a tela
    // oferecível na permissão da secretária (utils/regional-user-permissions.js); a API usa o
    // alias 'metas' => '/minhas-metas' (salesteams_app_api/config/regional_user_menus.php).
    path: "/minhas-metas",
    component: () => import("./views/minhas-metas/index"),
    meta: { authRequired: true, menu: { label: "Minhas Metas" } },
  },
  {
    // Meu Cartão (cartão de visita de conquistas). Pessoal da titular: o menu não aparece para
    // secretária; a API usa o alias 'cartao' => '/meu-cartao' (regional_user_menus.php).
    path: "/meu-cartao",
    component: () => import("./views/meu-cartao/index"),
    meta: { authRequired: true },
  },
  {
    path: "/guia-do-app",
    component: () => import("./views/guia-do-app"),
    meta: { authRequired: true, menu: { label: "Guia do App" } },
  },
  {
    path: "/faq",
    component: () => import("./views/faq"),
    meta: { authRequired: true, menu: { label: "Suporte - FAQ" } },
  },
  {
    path: "/atualizacad",
    component: () => import("./views/atualizacao-cadastral"),
    meta: { authRequired: true },
  },
  {
    // Exclusao de conta. Exigida pela diretriz 5.1.1(v) da App Store para
    // qualquer aplicativo que permita criar conta — e este painel tem cadastro
    // publico. Fica FORA do menu de proposito (nao e algo a se oferecer no
    // caminho de todo mundo), mas acessivel por link direto a partir do perfil.
    path: "/conta/excluir",
    component: () => import("./views/account-delete"),
    meta: { authRequired: true },
  },
  {
    path: "/tickets",
    component: () => import("./views/tickets"),
    meta: { authRequired: true, menu: { label: "Suporte - Tickets" } },
  },
  {
    path: "/tickets/:id",
    component: () => import("./views/tickets-view"),
    meta: { authRequired: true },
  },
  {
    path: "/courses",
    component: () => import("./views/courses/list"),
    meta: { authRequired: true },
  },
  {
    path: "/courses/:course",
    component: () => import("./views/courses/view"),
    meta: { authRequired: true },
  },
  {
    path: "/courses/:course/:module/:lesson",
    component: () => import("./views/courses/view"),
    meta: { authRequired: true },
  },
  {
    path: "/informatives",
    component: () => import("./views/informatives/index"),
    meta: { authRequired: true, menu: { label: "Informativos" } },
  },
  {
    path: "/informatives/:id",
    component: () => import("./views/informatives/view"),
    meta: { authRequired: true },
  },
  {
    path: "/events",
    component: () => import("./views/events/index"),
    meta: { authRequired: true, menu: { label: "Eventos" } },
  },
  {
    path: "/events/:id",
    component: () => import("./views/events/view"),
    meta: { authRequired: true },
  },
  {
    path: "/clients",
    component: () => import("./views/clients/index"),
    meta: { authRequired: true, menu: { label: "Clientes" } },
  },
  {
    path: "/clients/create",
    component: () => import("./views/clients/create"),
    meta: { authRequired: true },
  },
  {
    path: "/clients/import",
    component: () => import("./views/clients/import"),
    meta: { authRequired: true },
  },
  {
    path: "/clients/import/:id",
    component: () => import("./views/clients/import-file"),
    meta: { authRequired: true },
  },
  {
    path: "/clients/:id",
    component: () => import("./views/clients/edit"),
    meta: { authRequired: true },
  },
  {
    path: "/404",
    component: () => import("./views/404"),
    meta: { authRequired: false },
  },
  {
    path: "/apn",
    name: "ApnIndex",
    component: () => import("./views/apn/index.vue"),
    meta: { authRequired: true, menu: { label: "Convite APN", hidden: false } },
  },
  {
    // Pesquisa NPS pública (sem login). Precisa vir antes de "/:sponsor".
    path: "/nps",
    name: "Nps",
    component: () => import("./views/nps.vue"),
    meta: { authRequired: false },
  },
  {
    path: "/apn/cadastro/:uuid",
    name: "ApnCadastro",
    component: () => import("./views/apn/cadastro.vue"),
    meta: { authRequired: false },
  },
  {
    path: "/:sponsor",
    redirect: "/register/:sponsor",
  },
  {
    path: "/notasfiscais/apvsbrasil",
    component: () => import("./views/notasfiscais/apvsbrasil"),
    meta: { authRequired: true, menu: { label: "Financeiro - APVS Brasil" } },
  },
  {
    path: "/nfs-brasil/:sistema/:mes/:ano/:line_id",
    name: "MesNotasBrasil",
    component: () => import("./views/notasfiscais/mesbrasil.vue"),
    meta: { authRequired: true },
  },
  {
    path: "/notasfiscais/consultor/:sistema/:mes/:ano/:line_id/:id_consultor",
    name: "MesNotasBrasilConsultor",
    component: () => import("./views/notasfiscais/mesbrasilconsultor.vue"),
  },
  {
    path: "/notasfiscaistruck/consultor/:sistema/:mes/:ano/:line_id/:id_consultor",
    name: "MesNotasTruckConsultor",
    component: () => import("./views/notasfiscais/mestruckconsultor.vue"),
  },
  {
    path: "/nfs-brasil/visualizarnota/:idNota",
    name: "VisualizarNotaBrasil",
    component: () => import("./views/notasfiscais/notabrasil.vue"),
    meta: { authRequired: true },
  },
  {
    path: "/notasfiscais/apvstruck",
    component: () => import("./views/notasfiscais/apvstruck"),
    meta: { authRequired: true, menu: { label: "Financeiro - APVS Truck" } },
  },
  {
    path: "/nfs-truck/:sistema/:mes/:ano/:line_id",
    name: "MesNotasTruck",
    component: () => import("./views/notasfiscais/mestruck.vue"),
    meta: { authRequired: true },
  },
  {
    path: "/nfs-truck/visualizarnota/:idNota",
    name: "VisualizarNotaTruck",
    component: () => import("./views/notasfiscais/notatruck.vue"),
    meta: { authRequired: true },
  },
  {
    path: "/leads/leads",
    name: "LeadsApvs",
    component: () => import("./views/leads/leads.vue"),
    meta: { authRequired: true, menu: { label: "Leads" } },
  },
  {
    path: "/lead/:id",
    name: "lead.show",
    component: () => import("./views/leads/leadshow.vue"),
    meta: { authRequired: true },
  },
  // Afiliados — painel do consultor/regional
  {
    path: "/afiliados/lista",
    name: "afiliados",
    component: () => import("./views/afiliados/index.vue"),
    meta: { authRequired: true, menu: { label: "Afiliados - Meus Afiliados" } },
  },
  {
    path: "/afiliados/leads",
    name: "AfiliadosLeads",
    component: () => import("./views/afiliados/leads.vue"),
    meta: { authRequired: true, menu: { label: "Afiliados - Leads Indicados" } },
  },
  {
    path: "/afiliados/convertidos",
    name: "AfiliadosConvertidos",
    component: () => import("./views/afiliados/convertidos.vue"),
    meta: { authRequired: true, menu: { label: "Afiliados - Leads Convertidos" } },
  },
  {
    path: "/afiliados/ranking",
    name: "AfiliadosRanking",
    component: () => import("./views/afiliados/ranking.vue"),
    meta: { authRequired: true, menu: { label: "Afiliados - Ranking" } },
  },
  // Afiliados — cadastro público
  {
    path: "/afiliados/cadastro/:uuid",
    name: "AfiliadosCadastro",
    component: () => import("./views/afiliados/cadastro.vue"),
    meta: { authRequired: false },
  },
  // Afiliado — ambiente próprio
  {
    path: "/login/afiliado",
    name: "LoginAfiliado",
    component: () => import("./views/login-afiliado.vue"),
    meta: { authRequired: false },
  },
  {
    path: "/afiliado",
    name: "AfiliadoHome",
    component: () => import("./views/afiliado/home.vue"),
    meta: { authRequired: false },
  },
  {
    path: "/afiliado/leads",
    name: "AfiliadoLeads",
    component: () => import("./views/afiliado/leads.vue"),
    meta: { authRequired: false },
  },
  {
    path: "/afiliado/comissoes",
    name: "AfiliadoComissoes",
    component: () => import("./views/afiliado/comissoes.vue"),
    meta: { authRequired: false },
  },
];

export default routes;
